"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
(0, core_1.addRoute)({
    name: "settings.general",
    path: "general",
    component: "GeneralSettings"
});
let GeneralSettings = class GeneralSettings extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    sendmailResult;
    ux;
    b_7315092382398562_modalBindings;
    dataMembers = ['sendmailResult', 'ux', 'b_7315092382398562_modalBindings'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                sendmailResult: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "sm",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return;
        }
        return null;
    }
    async act_7315092382398562_closeModal_5296_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async act_1269646916756998_setData_5298_getActionArgs($event) {
        return {
            path: "sendmailResult",
            value: null,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_1269646916756998_setData_5302_getActionArgs($event) {
        return {
            path: "sendmailResult",
            value: true,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_1269646916756998_request_5300_getActionArgs($event) {
        return {
            operation: "post_sendmail_test",
            data: {},
        };
    }
    async evh_1269646916756998_clickPreventStop(event, scope) {
        return await this.actions.evh_1269646916756998_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_5296 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_5296_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_5295 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_5296,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_5295],
        });
        const act_1269646916756998_setData_5298 = new core_1.actions.SetDataAction({
            actionArgs: this.act_1269646916756998_setData_5298_getActionArgs,
            events: [],
        });
        const evh_1269646916756998_clickPreventStop_5297 = new core_1.actions.EventHandlerImpl({
            action: act_1269646916756998_setData_5298,
            event: "click.prevent.stop",
            displayName: "setData",
        });
        const act_1269646916756998_setData_5302 = new core_1.actions.SetDataAction({
            actionArgs: this.act_1269646916756998_setData_5302_getActionArgs,
            events: [],
        });
        const evh_1269646916756998_success_5301 = new core_1.actions.EventHandlerImpl({
            action: act_1269646916756998_setData_5302,
            event: "success",
            displayName: "setData",
        });
        const act_1269646916756998_request_5300 = new core_1.actions.RequestAction({
            actionArgs: this.act_1269646916756998_request_5300_getActionArgs,
            displayName: "sendmail",
            events: [evh_1269646916756998_success_5301],
        });
        const evh_1269646916756998_clickPreventStop_5299 = new core_1.actions.EventHandlerImpl({
            action: act_1269646916756998_request_5300,
            event: "click.prevent.stop",
            displayName: "sendmail",
        });
        const evh_1269646916756998_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1269646916756998_clickPreventStop_5297, evh_1269646916756998_clickPreventStop_5299],
        });
        return {
            act_7315092382398562_closeModal_5296,
            evh_7315092382398562_close_5295,
            evh_7315092382398562_close,
            act_1269646916756998_setData_5298,
            evh_1269646916756998_clickPreventStop_5297,
            act_1269646916756998_setData_5302,
            evh_1269646916756998_success_5301,
            act_1269646916756998_request_5300,
            evh_1269646916756998_clickPreventStop_5299,
            evh_1269646916756998_clickPreventStop,
            sendmail: act_1269646916756998_request_5300,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], GeneralSettings.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], GeneralSettings.prototype, "onSize", null);
GeneralSettings = __decorate([
    (0, vue_property_decorator_1.Component)()
], GeneralSettings);
exports.default = GeneralSettings;
vue_property_decorator_1.Vue.component("GeneralSettings", GeneralSettings);
